export const EMPTY_CELL = '—'
